import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountStatusHistoryQuery(
    $filters: [Filter]
    $companyId: ID!
    $usageUnitId: ID!
  ) {
    Me {
      id
      Company(id: $companyId) {
        UsageUnit(id: $usageUnitId) {
          data: countLockPeriods(options: { filters: $filters })
        }
      }
    }
  }
`
